export default {
  name: 'IconRefresh'
};